<template>
  <div class="container">
    <h1>
      <b-icon icon="file-earmark-spreadsheet"></b-icon> Course Grading

      <div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
<Help id="10" />

</div>
    </h1>
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Student Data</div>
   <div class="panal-body">

     <div class="row">
       <div class="col-md-10">
         <div class="row" v-if="personalData.length > 0">
              <div class="col-md-3 col-sm-12 ">
                <div class="profileData">Student Name  </div>
              </div>
              <div class="col-md-9 col-sm-12 ">
                <div class="profileData2"> {{personalData[0].FirstNameEN+' '+personalData[0].SecondNameEN+' '+personalData[0].ThirdNameEN}}</div>
              </div>
              <!-- <div class="app-stu col-md-6 col-sm-12">
                <div class="title">Year/Term: <span>{{Transcript[0].Name}}</span></div> 
              </div>
              <div class="app-stu col-md-6 col-sm-12">
                 <div class="title">CGPA : <span>{{TranscriptDetails[0].CGPA}}</span></div> 
              </div> -->
              <div class="col-md-3 col-sm-12 ">
                <div class="profileData">Faculty Name </div> 
                </div>
              <div class="col-md-9 col-sm-12 ">
               <div class="profileData2">{{personalData[0].FacultyName_EN}}</div>
              </div>
           
            </div>
            </div>
       <div class="col-md-2">

<div class="app-stu-photo"><img src="../../assets/SU_Logo.png" /></div>
       </div>
     </div>

  
            


<div class="clearfix"></div>

</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Search List</div>
          <div class="panal-body">
            <div>

<b-link
  :href="SurveyUrl()"
  target="_blank"
  class="btn btn-primary"
   v-if="!showTable"
>
  Make a Survey
</b-link>


            </div>
            <div
              v-if="message"
              class="alert"
              :class="successful ? 'alert-success' : 'alert-danger'"
            >
              {{ message }}
            </div>
            
            <div class="table-responsive" v-else id="tableList"  v-show="showTable">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Course Name</th>
                    <th scope="col">Course code</th>
                    <th scope="col">Course type</th>
                    <!-- <th scope="col">Instructor Name</th> -->
                    <!-- <th scope="col">Day and Time</th> -->
                    <th scope="col">Select</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="courses.length == 0">
                    <td colspan="7">No Data</td>
                  </tr>

                  <tr
                    v-else
                    v-for="item in courses"
                    v-bind:Key="item.StudentID"
                  >
                    <td>{{ item.CourseName }}</td>
                    <td>{{ item.CourseCode }}</td>
                    <td>{{ item.SectionsList.map(x=>x.TypeNameEN).join('-') }}</td>
                    <!-- <td>{{ item.SectionsList.map(x=>x.ScheduleLst.map(p=>p.ProfessorLst.map(n=>n.Name))).join(';') }}</td> -->
                    <!-- <td>{{ item.WeekDay  }}  - {{item.StartTime}} - {{item.EndTime}}</td> -->
                   
                    <td>
                      <b-button
                        variant="success"
                          v-b-modal.QuizModal
                        
                        @click="openQuizPanel(item)"
                        v-bind:Key="item.CourseNameEN"
                        >Select</b-button
                      >
                     <!-- <b-button variant="warning ml-2 " v-b-modal.courseModal @click="QuickQuizez(item)"
                        v-bind:Key="item.CourseNameEN">Course Work</b-button> -->
                      

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
   <!-- Modal -->
     <b-modal id="courseModal"  class="modal model fade content panal moldal-lg"  hide-header centered>
    
     <div  class="modal-body" >
          <div class="panal-header">course work</div>
          <div class="panal-body">
               <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
            
                    <th scope="col">Course Name EN</th>
                    <th scope="col">course code</th>
                    <th scope="col">QuizName</th>
                    <th scope="col">Max Degree</th>
                    <th scope="col">mark</th>
                    
                  </tr>
                </thead>
                <tbody>
                
                  <tr  v-if="QUIZEZ.length == 0">
                    <td colspan="5">No Data</td>
                  </tr>
                <tr v-else v-for="quiz in QUIZEZ" :key="quiz.CourseCode">
  <td>{{ selectedCourse.CourseName }}</td>
  <td>{{ selectedCourse.CourseCode }}</td>
  <td>{{ quiz.QuizName }}</td>
  <td>{{ quiz.max_degree }}</td>
  <td>{{ quiz.mark }}</td>
</tr>
                </tbody>
              </table>
            </div>
            </div>
      </div>

  </b-modal>

     <b-modal id="QuizModal"  class="modal model fade content panal moldal-lg"  hide-header centered>
    
     <div  class="modal-body" >
          <div class="panal-header">Quiz Result</div>
          <div class="panal-body">
               <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                 <thead class="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Activity Name</th>
                    <th scope="col">Activity Group</th>
                    <th scope="col">Grade</th>
                    <th scope="col">Max Grade</th>
                    
                  </tr>
                </thead>
                   <tbody>
                  <tr v-if="Grading.length == 0">
                    <td colspan="5">No Data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="item in Grading"
                    v-bind:Key="item.CourseNameEN"
                  >
                    <td></td>
                    <td>{{ item.TemplateDetails }}</td>
                    <td>{{ item.Groups }}</td>
                    <td>{{ item.StudentDegree }}</td>
                    <td>{{ item.MaxDegree }}</td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
      </div>

  </b-modal>    
    <!-- <input id='button' type='checkbox' v-model="checked"> -->
    <div  div v-if="checked" class="model">
      <div class=" content">
        <div class="panal mt-20">
          <div class="panal-header">Quiz Results</div>
          <div class="panal-body">
            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Activity Name</th>
                    <th scope="col">Activity Group</th>
                    <th scope="col">Grade</th>
                    <th scope="col">Max Grade</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="Grading.length == 0">
                    <td colspan="5">No Data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="item in Grading"
                    v-bind:Key="item.CourseNameEN"
                  >
                    <td></td>
                    <td>{{ item.TemplateDetails }}</td>
                    <td>{{ item.Groups }}</td>
                    <td>{{ item.StudentDegree }}</td>
                    <td>{{ item.MaxDegree }}</td>
                    
                  </tr>
                </tbody>
              </table>
             
            </div>
             <button @click="checked = false" class="btn btn-primary float-right">
  Close
</button>
          </div>
        </div>
      </div>
    </div>
 
  </div>
</template>
<script>
import studentData from "../../services/student/studentDataServices";
import Help from '../Help.vue';
//import ApplicantService from '../../services/Applicant/Applicant.service';
export default {
  components: { Help },
  name: "CourseGrading",
  data() {
    return {
      isLoading: true,
      selected: null,
      show: true,
      isHidden: true,
      Grading: [],
     
    QUIZEZ: [],        // all quizzes
    selectedCourse: null,  // course selected for the modal
      personalData: [],
      message: "",
      courses: "",
      quazs: [],
      CourseNameEN: "",
      currentItem:"",
      info:"",
      checked:false,
       showCourseWork: false, // 👈 must be defined
       showPanel: false,
       StudentSurvey:{},
    };
  },
  methods:{
  

 
  QuickQuizez(course) {
  this.selectedCourse = course; // store the selected course
  this.isLoading = true;        // optional: show loader

  // Use course.CourseID (not item.CourseID)
  studentData.GetStudentQUICKQUIZEZ(this.currenUser.StudentID, course.CourseID, 1)
    .then((response) => {
      this.isLoading = false;

      // Response data from API
      this.QUIZEZ = response.data;

      // You **don't need to filter by CourseCode** here
      // unless you want to double-check
      // this.QUIZEZ = this.QUIZEZ.filter(q => q.CourseCode === course.CourseCode);

      console.log(this.QUIZEZ);
    })
    .catch((error) => {
      this.isLoading = false;
      this.QUIZEZ = [];  // clear old data
      this.message =
        (error.response && error.response.data && error.response.data.Message) ||
        error.message ||
        error.toString();

      if (error.response && error.response.status === 404) this.message = "";
      console.error(this.message);
    });
},


 openQuizPanel(item) {
    this.checked = true;  // 👈 show the custom panel
    this.getQuiz(item);   // 👈 load the quiz data
  },
  SurveyUrl() {
  // console.log(surveyUrl());
  return `https://sufacilities.su.edu.eg/api_login?token=${this.StudentSurvey.token}`;
//    return `https://sufacilities.su.edu.eg/api_login?token=${this.facilities.token}`;
},
    getQuiz(item){
    
          this.currentItem  = item;
          //this.currenUser.StudentID,item.CourseID,item.RoleReviewID  // 25096, 500, 2
          studentData.GetStudentActivityGrading(this.currenUser.StudentID,item.CourseID,2).then(
             (Response) => {
          this.isLoading = false;
          this.Grading = Response.data;
          // eslint-disable-next-line no-console
           console.log(this.Grading);
           this.checked =true
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);
          this.Grading = [];
          this.checked =true
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";

       
        }
      
          )
    },

 
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {

  

    
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.personalData = Response.data.StudentData;
        // eslint-disable-next-line no-console
         console.log(this.personalData);

      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status);

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    ),
      //this.currenUser.StudentID
      // studentData.GetStudentActivityGrading(25096, 366, 3).then(
      //   (Response) => {
      //     this.isLoading = false;
      //     this.Grading = Response.data;
      //     // eslint-disable-next-line no-console
      //     console.log(this.Grading);
      //   },
      //   (error) => {
      //     // eslint-disable-next-line no-console
      //     console.log(error.response.status);

      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // ),
      //this.currenUser.StudentID // 566
      studentData.getStudentSchedualeNew(this.currenUser.StudentID).then(
        (Response) => {
          this.isLoading = false;
          this.courses = Response.data;
          // eslint-disable-next-line no-console
          // console.log(this.Grading);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );

      
          studentData.StudentSurvey(this.currenUser.StudentID, "1").then(
        (Response) => {
          this.isLoading = false;
          this.StudentSurvey = Response.data;
            if (
      Response.data.success === true 
      // &&
      // Response.data.completed_all === false
    ) {
      this.showTable = false;
    } else {
      this.showTable = true;
    }
          // eslint-disable-next-line no-console
          console.log(Response.data);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        
  });


      
  },


  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >


.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;
 
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}

.profileData, .profileData2 {
    border: 1px dotted #646464;
    padding: 3px 10px;
    font-weight: 700;
    margin: 5px 0px;
}
.profileData {
    color: #285475;
}
.profileData2 {
    color: #ff8600;
}


@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
.model {
  background: rgba(30, 143, 255, 0.13);
  height: 1px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 1s ease 1s, height 1s ease;
  width: 0;
  z-index: 133;
}

.content {
  color: transparent;
  
  font-size: 2em;
  position: absolute;
  top: 50%;
  left:25%;
  transform: translate3d(0, -50%, 0);
  transition: color 0.5s ease;
  width: 50%;
  margin: auto;
}

label {
  color: rgba(30, 143, 255, 0.13);
  cursor: pointer;
  font-family: "Consolas", arial, sans-serif;
  font-size: 2em;
  position: fixed;
  left: 50%;
  top: 50%;
  text-transform: uppercase;
  transform: translate(-50%, -50%);
  transition: color 0.5s ease 0.5s;
}

input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  width: 0;
}
input:focus {
  outline: none;
}

input:checked {
  height: 40px;
  opacity: 1;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 1;
  -webkit-appearance: none;
  width: 40px;
  z-index: 135;
}
input:checked::after, input:checked:before {
  border-top: 1px solid #FFF;
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
  width: 100%;
}
input:checked::after {
  transform: rotate(-45deg);
}

input:checked + label {
  color: #FFF;
  transition: color 0.5s ease;
}

input:checked ~ .model {
  height: 100%;
  width: 100%;
  transition: width 1s ease, height 1s ease 1s;
}
input:checked ~ .model .content {
  color: #FFF;
  transition: color 0.5s ease 0.5s;
}
.modal-body {
    position: relative;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    padding: 0rem !important;
}
.modal-content {
      border-radius: 0.7rem !important;
}
.modal-backdrop{
      background: rgb(30 143 255 / 27%);
 
}
@media (min-width: 576px) {
    .modal-dialog {
        max-width: 800px;
        margin: 1.75rem auto;
    }
}
</style>
